/*
 * $Id:: rootReducer.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import authReducer from '../pages/AuthenticatedPage/authenticationSlice';
import usersReducer from '../pages/ImpersonateUserPage/usersSlice';
import accountReducer from '../pages/MyAccountPage/accountSlice';
import finalizedApplicationsReducer from '../pages/MyApplicationsPage/finalizedApplicationsSlice';
import applicationImageReducer from '../pages/MyApplicationsPage/applicationImageSlice';
import draftApplicationsReducer from '../pages/MyDraftsPage/draftApplicationsSlice';
import ssoReducer from '../pages/SSOPage/ssoSlice';
import globalsReducer from './globalsSlice';
import literalsReducer from './literalsSlice';
import notificationsReducer from './notificationsSlice';
import onlineServicesReducer from '../pages/OnlineServicesPage/onlineServicesSlice';

const rootReducer = {
    auth: authReducer,
    literals: literalsReducer,
    globals: globalsReducer,
    account: accountReducer,
    notifications: notificationsReducer,
    sso: ssoReducer,
    finalizedApplications: finalizedApplicationsReducer,
    applicationImage: applicationImageReducer,
    draftApplications: draftApplicationsReducer,
    onlineServices: onlineServicesReducer,
    users: usersReducer,
};

export default rootReducer;
